import React, { useCallback, useContext } from 'react';
import { NavPage } from '../../services/NavService';
import { Cabinet, PieceListClient, PieceListConvertRequest } from '../../services/WebApiClient';
import { EditorContext } from '../EditorCommon/EditorContext';
import { usePromise } from '../EditorCommon/usePromise';
import { EditorNav } from '../EditorNav/EditorNav';
import { LoadSpinner } from '../LoadSpinner';
import { TopNav } from '../TopNav/TopNav';
import { PieceListTable } from './PieceListTable';
import { SaveButton } from './SaveButton';

export function PieceListEditor(props: {

}) {
    const ec = useContext(EditorContext);
    const pieceList = usePromise(useCallback(async () => {
        const client = new PieceListClient();
        const response = await client.convert(new PieceListConvertRequest({
            cabinet: new Cabinet(ec.cabinet)
        }));
        return response.pieceList;
    },
        [ec.cabinet]
    ))

    return (
        <div className="editor piecelist-editor">
            <TopNav header={ec.translator("piecelist header", "Stykliste")} />

            <div className="main-editor">
                {(pieceList === undefined)
                    ? <LoadSpinner />
                    : <PieceListTable pieceList={pieceList} />
                }

                

            </div>
            <EditorNav currentPage={NavPage.PieceList}
                nextButton={<SaveButton />}
            />
        </div>
    );
}
